import { render, staticRenderFns } from "./SlotKiosks.vue?vue&type=template&id=4909c579&scoped=true&"
import script from "./SlotKiosks.vue?vue&type=script&lang=js&"
export * from "./SlotKiosks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4909c579",
  null
  
)

export default component.exports